/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonPosition
 */
export interface PersonPosition {
    /**
     * 
     * @type {number}
     * @memberof PersonPosition
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof PersonPosition
     */
    y: number;
    /**
     * 
     * @type {boolean}
     * @memberof PersonPosition
     */
    isMale?: boolean;
}

export function PersonPositionFromJSON(json: any): PersonPosition {
    return PersonPositionFromJSONTyped(json, false);
}

export function PersonPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonPosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'isMale': !exists(json, 'is_male') ? undefined : json['is_male'],
    };
}

export function PersonPositionToJSON(value?: PersonPosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'x': value.x,
        'y': value.y,
        'is_male': value.isMale,
    };
}

